import { Controller } from "@hotwired/stimulus"

// Toggles the custom function form's type-specific fields: the API sections for REST/GraphQL
// ("http"), REST-only vs GraphQL-only fields within them, and the Procedure section for flows.
export default class extends Controller {
  static targets = ["select", "http", "rest", "graphql", "flow"]

  connect() {
    this.toggle()
    this.form = this.element.closest("form")
    this.skipHiddenFields = this.skipHiddenFields.bind(this)
    this.form?.addEventListener("submit", this.skipHiddenFields)
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.skipHiddenFields)
  }

  toggle() {
    const type = this.selectTarget.value
    this.show(this.httpTargets, type !== "flow")
    this.show(this.restTargets, type === "rest")
    this.show(this.graphqlTargets, type === "graphql")
    this.show(this.flowTargets, type === "flow")
  }

  show(groups, visible) {
    groups.forEach((group) => group.classList.toggle("hidden", !visible))
  }

  // Don't submit fields for the other types (e.g. a flow has no auth source). Done at submit time,
  // not on toggle, because rich editors (markdown, ace) initialize read-only on a disabled field.
  skipHiddenFields() {
    const groups = [...this.httpTargets, ...this.restTargets, ...this.graphqlTargets, ...this.flowTargets]
    groups
      .filter((group) => group.classList.contains("hidden"))
      .forEach((group) => group.querySelectorAll("input, select, textarea").forEach((input) => { input.disabled = true }))
  }
}
